export enum SYS_ENV {
  D = 'desktop',
  M = 'mobile',
  T = 'tablet'
}

export const enum DEFAULT {
  L = 'en-US',
  C = 'us'
}

export enum MC_ANALYTICS {
  PAGE_SECTION = 'body:manage my trips:Trip Preparedness',
  EVENT_DETAIL = 'manage my trips',
  COMPONENT_TYPE = 'banner',
  COMPONENT_NAME = 'Trip Preparedness',
  LINK_NAME = 'Edit Trip Requirements',
  LANDING_HUB = 'Landing Hub',
  TRIPREQUIREMENTS = 'TRIPREQUIREMENTS'
}

export const enum USER_LOGGED_IN_STATUS {
  UNAUTHENTICATED = 'unauthenticated',
  AUTHENTICATED = 'authenticated',
  HOT = 'hot',
  COLD = 'cold'
}

export const enum ON_LOAD {
  NAME = 'page load',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated'
}

export const enum ANALYTICS_EVENT {
  PAGE_LOAD = 'page load',
  SUB_PAGE_LOAD = 'subpage load',
  CLICK = 'click',
  MODAL_LOAD = 'modal load',
  CUSTOM_EVENT = 'custom event'
}

export const enum CLICK_TYPE {
  LINK = 'link',
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  TOGGLE = 'toggle'
}

export const enum EVENT_TYPE {
  CTA = 'cta',
  LINK = 'link'
}

export const enum DATA_ANALYTICS {
  HREF = 'href',
  BODY = 'body',
  HTTP = 'http',
  OPENS = '.opens',
  CLEAR = 'clear',
  CONTINUE = 'continue',
  MODIFY = 'modify',
  CONFIRM_AND_CONTINUE = 'confirm and continue',
  BUTTON = 'button',
  CTA_CLICK = 'CTA click',
  LINK_CLICK = 'link click',
  CTA_BODY = 'cta body',
  EMAIL_SPLIT_SYMBOL = '@',
  EXTERNAL_LINK = 'external link',
  INTERNAL_LINK = 'internal link',
  LINK = 'link'
}

export enum TRIPS_LOAD {
  BANNER = 'banner',
  SOURCE = 'page content',
  DEFAULT = 'default message',
  OF = 'of',
  MIXED = 'mixed',
  MILES = 'miles',
  CASH = 'case',
  OR = 'or',
  BAN = 'ban'
}

export enum CHECKIN_STATUS {
  NONE = 'none',
  ALL = 'all',
  PARTIAL = 'partial',
  AVAILABLE = 'checkin available',
  UNAVAILABLE = 'checkin unavailable'
}
